import { render, staticRenderFns } from "./apiJewelTypeList.vue?vue&type=template&id=d52fdcb4&scoped=true&"
import script from "./apiJewelTypeList.vue?vue&type=script&lang=js&"
export * from "./apiJewelTypeList.vue?vue&type=script&lang=js&"
import style0 from "./apiJewelTypeList.vue?vue&type=style&index=0&id=d52fdcb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52fdcb4",
  null
  
)

export default component.exports